import {NgModule} from '@angular/core'
import {CommonModule} from '@angular/common'
import {FormsModule, ReactiveFormsModule} from '@angular/forms'

import {NgbModule} from '@ng-bootstrap/ng-bootstrap'
import {NgSelectModule} from '@ng-select/ng-select'
import {TabsModule} from 'ngx-bootstrap/tabs'
import {CollapseModule} from 'ngx-bootstrap/collapse'
import {BsDatepickerModule} from 'ngx-bootstrap/datepicker'
import {TimepickerModule} from 'ngx-bootstrap/timepicker'

import {BsDropdownModule} from 'ngx-bootstrap/dropdown'
import {AlertModule} from 'ngx-bootstrap/alert'

import {MultiselectDropdownModule} from './multiselect-dropdown/multiselect-dropdown.module'

import {DomainSelectorComponent} from './domain-selector/domain-selector.component'
import {DomainTreeComponent} from './domain-tree/domain-tree.component'
import {PinnedDomainComponent} from './domain-tree/pinned-domain.component'
import {TerminalTypeSelectorComponent} from './terminal-type-selector/terminal-type-selector.component'
import {RtProgressBarComponent} from './rt-progress-bar/rt-progress-bar.component'

import {SearchFilterModule} from './search-filter/search-filter.module'
import {DateFilterModule} from './date-filter/date-filter.module'
import {TransactionChartComponent} from './transaction-chart/transaction-chart.component'
import {TerminalSelectorComponent} from './terminal-selector/terminal-selector.component'
import {ContractSelectorComponent} from './contract-selector/contract-selector.component'
import {ContractSelectorNewModalComponent} from './contract-selector/contract-selector-new-modal.component'
import {DataInputComponent} from './data-input/data-input.component'

import {ScrollListModule} from './scroll-list/scroll-list.module'
import {FilterListModule} from './filter-list/filter-list.module'

import {AdvancedConfigurationFormComponent} from './advanced-configuration-form/advanced-configuration-form.component'

import {LoaderLineModule} from './loader-line/loader-line.module'
import {NgxPermissionsModule} from 'ngx-permissions'
import {KeysPipe} from './pipes/keys.pipe'
import {UCFirstPipe} from './pipes/ucfirst.pipe'
import {ChunkPipe} from './pipes/chunk.pipe'
import {DomainSelectorNewModalComponent} from './domain-selector/domain-selector-new-modal.component'

import {RouterModule} from '@angular/router'
import {MultiTzDateComponent} from './multi-tz-date/multi-tz-date.component'
import {TooltipModule} from 'ngx-bootstrap/tooltip'
import {MultiTzSelectComponent} from './multi-tz-date/multi-tz-select.component'
import {ScrollEndDirective} from './directives/scroll-end/scroll-end.directive'

import {HighlightPipe} from './pipes/highlight.pipe'
import {TerminalEventsDateJumperComponent} from './data-list/components/terminal-events-date-jumper/terminal-events-date-jumper.component'
import {TerminalEventsFilterComponent} from './data-list/components/terminal-events-filter/terminal-events-filter.component'
import {TerminalEventsListComponent} from './data-list/components/terminal-events-list/terminal-events-list.component'
import {TerminalEventsJumperComponent} from './data-list/components/terminal-events-jumper/terminal-events-jumper.component'
import {TerminalEventDetailTogglerComponent} from './data-list/components/terminal-event-detail-toggler/terminal-event-detail-toggler.component'
import {ScrollingModule} from '@angular/cdk/scrolling'
import {KeyValueListInputComponent} from './key-value-list-input/key-value-list-input.component'
import {OrderedMultiSelectComponent} from './ordered-multi-select/ordered-multi-select.component'
import {InfiniteScrollListComponent} from './infinite-scroll-list/infinite-scroll-list.component'
import {DomainFieldComponent} from './domain-field/domain-field.component'
import {NewUserComponent} from '../features/administration/users/new-user/new-user.component'
import {RoleSelectorComponent} from '../features/administration/users/role-selector/role-selector.component'
import {CopyFormatExcelDirective} from './directives/copy-format-excel/copy-format-excel.directive'
import {DragAndDropDirective} from '@app/core/directives'
import {DefaultDomainComponent} from './domain-tree/default-domain/default-domain.component'
import {ModalModule} from 'ngx-bootstrap/modal'
import {BreadcrumbsModule} from './breadcrumbs/breadcrumbs.module'
import {OptionSelectComponent} from './option-select/option-select.component'
import {HardCodedStringReplacementPipe} from './pipes/hardcodedStringReplacement.pipe'
import {CustomContextMenuComponent} from './custom-context-menu/custom-context-menu.component'
import {AppDebugComponent} from './app-debug/app-debug.component'
import {CdkDrag, CdkDragHandle} from '@angular/cdk/drag-drop'
import {PortalModule} from '@angular/cdk/portal'
import {UserSelectorComponent} from './user-selector/user-selector.component'
import {OtpInputComponent} from './otp-input'
import {DynamicInputComponent} from './dynamic-input/dynamic-input.component'
import {DynamicFiltersComponent} from './data-list/components/dynamic-filters/dynamic-filters.component'
import {TerminalEventsDetailComponent} from './data-list/components/terminal-events-detail/terminal-events-detail.component'

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgbModule,
    // TypeaheadModule.forRoot(),
    TabsModule,

    CollapseModule,
    // DynamicFormModule,
    FilterListModule,
    MultiselectDropdownModule,
    ScrollListModule,
    LoaderLineModule,
    SearchFilterModule,
    BsDatepickerModule,
    TimepickerModule,
    DateFilterModule,
    NgSelectModule,
    NgxPermissionsModule.forChild(),
    BsDropdownModule,
    RouterModule.forChild([]),
    TooltipModule,
    AlertModule,
    ScrollingModule,
    FormsModule,
    TabsModule,
    ModalModule,
    BreadcrumbsModule,
    CdkDrag,
    CdkDragHandle,
    PortalModule,
  ],
  declarations: [
    DomainFieldComponent,
    DomainSelectorComponent,
    NewUserComponent,
    RoleSelectorComponent,
    DomainSelectorNewModalComponent,
    ContractSelectorComponent,
    ContractSelectorNewModalComponent,
    DataInputComponent,
    CustomContextMenuComponent,
    AdvancedConfigurationFormComponent,
    DomainTreeComponent,
    PinnedDomainComponent,
    TerminalTypeSelectorComponent,
    RtProgressBarComponent,
    TransactionChartComponent,
    TerminalSelectorComponent,
    UCFirstPipe,
    KeysPipe,
    HardCodedStringReplacementPipe,
    ChunkPipe,
    MultiTzDateComponent,
    MultiTzSelectComponent,
    ScrollEndDirective,
    HighlightPipe,
    TerminalEventsDateJumperComponent,
    TerminalEventsFilterComponent,
    TerminalEventsListComponent,
    DynamicFiltersComponent,
    TerminalEventsJumperComponent,
    TerminalEventsDetailComponent,
    DragAndDropDirective,
    OptionSelectComponent,
    UserSelectorComponent,
    TerminalEventDetailTogglerComponent,
    KeyValueListInputComponent,
    OrderedMultiSelectComponent,
    InfiniteScrollListComponent,
    CopyFormatExcelDirective,
    DefaultDomainComponent,
    AppDebugComponent,
    OtpInputComponent,
    DynamicInputComponent,
  ],
  exports: [
    DomainFieldComponent,
    BsDatepickerModule,
    BsDatepickerModule,
    TimepickerModule,
    CommonModule,
    FilterListModule,
    DomainSelectorComponent,
    ContractSelectorComponent,
    DataInputComponent,
    DomainTreeComponent,
    PinnedDomainComponent,
    TerminalTypeSelectorComponent,
    TerminalSelectorComponent,
    ScrollListModule,
    LoaderLineModule,
    SearchFilterModule,
    DateFilterModule,
    TransactionChartComponent,
    AdvancedConfigurationFormComponent,
    CustomContextMenuComponent,
    UCFirstPipe,
    KeysPipe,
    HardCodedStringReplacementPipe,
    NgxPermissionsModule,
    ChunkPipe,
    MultiTzDateComponent,
    MultiTzSelectComponent,
    AlertModule,
    TerminalEventsDateJumperComponent,
    TerminalEventsFilterComponent,
    TerminalEventsListComponent,
    DynamicFiltersComponent,
    TerminalEventsJumperComponent,
    TerminalEventsDetailComponent,
    TerminalEventDetailTogglerComponent,
    ScrollingModule,
    FormsModule,
    TabsModule,
    ModalModule,
    TerminalEventDetailTogglerComponent,
    KeyValueListInputComponent,
    NewUserComponent,
    RoleSelectorComponent,
    OrderedMultiSelectComponent,
    InfiniteScrollListComponent,
    DragAndDropDirective,
    DefaultDomainComponent,
    OptionSelectComponent,
    BreadcrumbsModule,
    AppDebugComponent,
    UserSelectorComponent,
    OtpInputComponent,
    DynamicInputComponent,
  ],
})
export class PayterSharedModule {}
